import { isTasksMapLightColor } from '@/api/tasksMap'

/** 地图人名圆：设计稿 32×32（未选中） */
export const TASKS_MAP_PERSON_MARKER_SIZE = 32
export const TASKS_MAP_PERSON_MARKER_BG = '#D9F0FF'
export const TASKS_MAP_PERSON_INITIALS_COLOR = '#00AEEF'

/** 选中后：人物实心蓝点 16×16；订单编号圈 32×32 */
export const TASKS_MAP_ORDER_MARKER_SIZE = 32
export const TASKS_MAP_SELECTED_ANCHOR_SIZE = 16
export const TASKS_MAP_NAME_LABEL_GAP_PX = 8
/** 选中路线最小视野跨度（约几百米），防止两点过近被缩成一团 */
export const TASKS_MAP_SELECTED_MIN_SPAN = 0.01
/** 仅在路线很紧凑时限制最大缩放，避免过度放大；多订单分散时不强行拉近 */
export const TASKS_MAP_SELECTED_MAX_ZOOM = 16

export function getPersonMarkerLabelColor(color: string): string {
  return isTasksMapLightColor(color) ? '#000000' : '#ffffff'
}

function escapeSvgText(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;')
}

function createCircleSvgIcon(options: {
  size: number
  fill: string
  stroke?: string
  strokeWidth?: number
  label?: string
  labelColor?: string
  fontSize?: number
  fontWeight?: number
}): google.maps.Icon {
  const {
    size,
    fill,
    stroke = '#ffffff',
    strokeWidth = 2,
    label = '',
    labelColor = '#ffffff',
    fontSize = 14,
    fontWeight = 700,
  } = options
  const r = size / 2 - strokeWidth / 2
  const cx = size / 2
  const cy = size / 2
  const text = label
    ? `<text x="${cx}" y="${cy}" dy="0.35em" text-anchor="middle" fill="${labelColor}" font-family="SFPro, 'SF Pro', 'SF Pro Display', -apple-system, BlinkMacSystemFont, system-ui, sans-serif" font-size="${fontSize}" font-weight="${fontWeight}">${escapeSvgText(label)}</text>`
    : ''

  const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
  <circle cx="${cx}" cy="${cy}" r="${r}" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}"/>
  ${text}
</svg>`.trim()

  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: new google.maps.Size(size, size),
    size: new google.maps.Size(size, size),
    anchor: new google.maps.Point(size / 2, size / 2),
  }
}

/** 未选中：缩写圆 #D9F0FF + #00AEEF 缩写 */
export function createPersonInitialsIcon(initials: string): google.maps.Icon {
  const text = (initials || '?').trim().slice(0, 2).toUpperCase() || '?'
  return createCircleSvgIcon({
    size: TASKS_MAP_PERSON_MARKER_SIZE,
    fill: TASKS_MAP_PERSON_MARKER_BG,
    stroke: TASKS_MAP_PERSON_MARKER_BG,
    strokeWidth: 0,
    label: text,
    labelColor: TASKS_MAP_PERSON_INITIALS_COLOR,
    fontSize: 14,
    fontWeight: 900,
  })
}

/** @deprecated */
export function createPersonCircleIcon(_color: string): google.maps.Symbol {
  return {
    path: google.maps.SymbolPath.CIRCLE,
    scale: TASKS_MAP_PERSON_MARKER_SIZE / 2,
    fillColor: TASKS_MAP_PERSON_MARKER_BG,
    fillOpacity: 1,
    strokeWeight: 0,
  }
}

/** 选中后 orders 编号点：32×32，#00AEEF，白边，白字序号 */
export function createOrderNumberIcon(sequence: number): google.maps.Icon {
  return createCircleSvgIcon({
    size: TASKS_MAP_ORDER_MARKER_SIZE,
    fill: TASKS_MAP_PERSON_INITIALS_COLOR,
    stroke: '#ffffff',
    strokeWidth: 2,
    label: String(sequence),
    labelColor: '#ffffff',
    fontSize: 14,
    fontWeight: 700,
  })
}

/** @deprecated 使用 createOrderNumberIcon */
export function createOrderCircleIcon(_color?: string): google.maps.Symbol {
  return {
    path: google.maps.SymbolPath.CIRCLE,
    scale: TASKS_MAP_ORDER_MARKER_SIZE / 2 - 1,
    fillColor: TASKS_MAP_PERSON_INITIALS_COLOR,
    fillOpacity: 1,
    strokeColor: '#ffffff',
    strokeWeight: 2,
  }
}

/**
 * 选中后「原本名字点」：#00AEEF 实心圆，无缩写。
 * 全名白框用单独 label 贴在右侧。
 */
export function createSelectedPersonAnchorIcon(): google.maps.Icon {
  return createCircleSvgIcon({
    size: TASKS_MAP_SELECTED_ANCHOR_SIZE,
    fill: TASKS_MAP_PERSON_INITIALS_COLOR,
    stroke: '#ffffff',
    strokeWidth: 2,
  })
}

/** 有人选中时，其他人显示为缩点 */
export function createCondensedPersonDotIcon(color: string): google.maps.Symbol {
  return {
    path: google.maps.SymbolPath.CIRCLE,
    scale: 6,
    fillColor: color || TASKS_MAP_PERSON_MARKER_BG,
    fillOpacity: 1,
    strokeColor: '#ffffff',
    strokeWeight: 1,
  }
}

export function createHiddenAnchorIcon(): google.maps.Symbol {
  return {
    path: google.maps.SymbolPath.CIRCLE,
    scale: 0,
    fillOpacity: 0,
    strokeOpacity: 0,
  }
}
